import {
  MEDIA_UPLOAD_FILE_STATUS,
  MediaState,
} from '../domain/media-file.types';
import { MediaEvent } from '../media.events';
import { updateFile } from '../media.helpers';

export const filesStatusReducer = (
  state: MediaState,
  event: MediaEvent
): MediaState => {
  switch (event.type) {
    case 'MEDIA/SET_URL':
      return updateFile(state, event.id, (file) => ({
        ...file,
        url: event.url,
      }));

    case 'MEDIA/MEDIA_LOAD_STARTED':
      return updateFile(state, event.id, (file) => ({
        ...file,
        mediaStatus: 'loading',
        error: undefined,
      }));

    case 'MEDIA/MEDIA_LOADED':
      return updateFile(state, event.id, (file) => ({
        ...file,
        mediaStatus: 'loaded',
        error: undefined,
      }));

    case 'MEDIA/MEDIA_ERROR':
      return updateFile(state, event.id, (file) => ({
        ...file,
        mediaStatus: 'error',
        error: 'Ошибка при загрузке файла',
      }));

    case 'MEDIA/PROCESSING_STARTED':
      return updateFile(state, event.id, (file) =>
        file.status === 'added' || file.status === 'error'
          ? {
              ...file,
              status: MEDIA_UPLOAD_FILE_STATUS.processing,
              error: undefined,
            }
          : file
      );

    case 'MEDIA/PROCESSING_SUCCEEDED':
      return updateFile(state, event.id, (file) =>
        file.status === 'processing'
          ? { ...file, status: MEDIA_UPLOAD_FILE_STATUS.ready }
          : file
      );

    case 'MEDIA/UPLOAD_SUCCEEDED':
      return updateFile(state, event.id, (file) =>
        file.status === 'ready' || file.status === 'processing'
          ? {
              ...file,
              status: MEDIA_UPLOAD_FILE_STATUS.uploaded,
              serverId: event.serverId,
              url: event.url,
              file: undefined,
            }
          : file
      );

    case 'MEDIA/UPLOAD_FAILED':
      return updateFile(state, event.id, (file) =>
        file.status !== MEDIA_UPLOAD_FILE_STATUS.removed
          ? {
              ...file,
              status: MEDIA_UPLOAD_FILE_STATUS.error,
              error: event.error,
            }
          : file
      );

    default:
      return state;
  }
};
